<template>
    <div class="shop-wrapper">
        <div id="orders-list" class="section">
            <!-- Container -->
            <div class="container">

                <!-- Orders List -->
                <div class="columns account-header">
                    <div class="column main-column is-tablet-landscape-padded">
                        <div class="account-title">
                            <h2>RESUMEN DE CUENTA</h2>
                            <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="brand-filigrane">
                        </div>

                        <!-- Account tabs -->
                        <div class="tabs account-tabs has-controls">
                            <navigation></navigation>
                        </div>

                        <!-- Controls -->
                        <div class="listing-controls">
                            <div class="layout-controls">
                                <!-- <a href="https://nephos.cssninja.io/orders.html"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span></a> -->
                                <!-- <a href="https://nephos.cssninja.io/orders-list.html"><span class="is-active"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg></span></a> -->
                            </div>
                            <!-- Sort -->
                            <div class="sort-box">
                                <div class="sort-box-select">
                                    <select data-placeholder="Default order" class="chosen-select-no-single" style="display: none;">
                                        <option>All Orders</option>
                                        <option>Pending</option>
                                        <option>In Progress</option>
                                        <option>Complete</option>
                                    </select>
                                        <!-- <div class="chosen-container chosen-container-single chosen-container-single-nosearch" title="" style="width: 100%;">
                                            <a class="chosen-single">
                                                <span>All Orders</span>
                                                <div><b></b></div>
                                            </a>
                                        <div class="chosen-drop">
                                        <div class="chosen-search">
                                            <input class="chosen-search-input" type="text" autocomplete="off" readonly="">
                                        </div>
                                        <ul class="chosen-results"></ul>
                                        </div> -->
                                    <!-- </div> -->
                                </div>
                            </div>
                        </div>
                        <!-- /Controls -->

                        <div id="orders-empty-placeholder" class="main-placeholder" v-show="accountStatus.length == 0">
                            <div class="placeholder-content">
                                <h3>Sin Registros</h3>
                                <p>No hay registros para mostrar. El detalle de su estado de cuenta se mostrará aquí, a partir del momento en que haya algún movimiento en su cuenta.</p>
                            </div>
                        </div>

                        <!-- Orders  -->
                        <div id="orders-main" class="columns is-account-grid is-multiline" v-show="accountStatus.length > 0">

                            <!--Loader-->
                            <!-- <div class="account-loader is-active "> -->
                                <!-- <div class="loader is-pulled is-loading"></div> -->
                            <!-- </div> -->

                            <!--Orders-->
                            <div class="column is-12">
                                <div class="order-long-card">

                                    <div class="table-container">
                                        <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                                            <thead>
                                                <tr class="order-header">
                                                    <th colspan="5">SALDO ACTUAL al {{ getNow() | dateLatin }}</th>                                                    
                                                    <th class="has-text-right">
                                                        <span class="tag is-large is-light">
                                                            {{ accountStatus[accountStatus.length -1].Saldo  | MoneyFormat }}
                                                        </span>
                                                    <th class="has-text-right">
                                                        <small class="seuo">*S.E.U.O.</small>
                                                    </th>
                                                </tr>                                                
                                                <tr>
                                                    <th>Fecha</th>
                                                    <th>Concepto</th>
                                                    <th>Comprobante</th>
                                                    <th>Nro. Remito</th>
                                                    <th class="has-text-right">Debe</th>
                                                    <th class="has-text-right">Haber</th>
                                                    <th class="has-text-right">Saldo</th>
                                                    <th class="has-text-right">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="( estado, index ) in accountStatus " 
                                                    v-bind:key="`estado-${index}`"
                                                    :class="[ estado.Concepto == 'TRANSPORTE' ? 'is-selected' : estado.Concepto]">
                                                    <td>{{ estado.Fecha | dateLatin }}</td>
                                                    <td>{{estado.Concepto}}</td>
                                                    <td>
                                                        {{estado.Num}}
                                                    </td>
                                                    <td>
                                                        <span v-if="estado.NroRemito != '' && estado.NroRemito != '0000-00000000'">
                                                            {{estado.NroRemito}}
                                                        </span>
                                                    </td>
                                                    <td class="has-text-right">
                                                        <span v-if="estado.Debe != 0">
                                                            {{ estado.Debe | MoneyFormat }}
                                                        </span>
                                                    </td>
                                                    <td class="has-text-right">
                                                        <span v-if="estado.Haber != 0">
                                                            {{estado.Haber | AbsolutNumber | MoneyFormat }}
                                                        </span>
                                                    </td>
                                                    <td class="has-text-right">{{estado.Saldo | MoneyFormat }}</td>
                                                    <!-- <td class="has-text-right">{{estado.Saldo | FloatToFixed }}</td> -->
                                                    <td class="has-text-right">
                                                        <a class="support" v-if="estado.Archivo"
                                                            @click="attemptGetDocument(estado.Archivo, 'file')">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download svg-button"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>                                        
                                    <!-- </div>
                                    <div class="table-container"> -->
                                        <!-- <footer class="card-footer ">
                                            <div class="column">
                                                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                                                    <button class="pagination-previous" :disabled="accountStatus.current_page == 1" 
                                                        @click.prevent="changePage(accountStatus.current_page-1)">Anterior</button>

                                                    <button class="pagination-next" :disabled="accountStatus.current_page == accountStatus.last_page" 
                                                        @click.prevent="changePage(accountStatus.current_page+1)">Próxima</button>
                                                
                                                    <ul class="pagination-list">
                                                        <li>
                                                            <button class="pagination-link" v-show="accountStatus.current_page > 2" 
                                                                @click.prevent="changePage(1)">1</button>
                                                        </li>

                                                        <li>
                                                            <span class="pagination-ellipsis" v-show="accountStatus.current_page > 3">&hellip;</span>
                                                        </li>
                                                            
                                                        <li>
                                                            <button class="pagination-link" v-show="accountStatus.current_page > 1" 
                                                                @click.prevent="changePage(accountStatus.current_page-1)">{{ accountStatus.current_page - 1 }}</button>                                                
                                                            
                                                        <li>
                                                            <span class="pagination-link is-current grey-button" aria-label="Page 46" aria-current="page">{{accountStatus.current_page}}</span>
                                                        </li>

                                                        <li>
                                                            <button class="pagination-link" 
                                                                v-show="accountStatus.current_page <= accountStatus.last_page-1" 
                                                                @click.prevent="changePage(accountStatus.current_page + 1)">{{ accountStatus.current_page + 1 }}</button>
                                                        </li>
                                                        
                                                        <li>
                                                            <span class="pagination-ellipsis" 
                                                                v-show="accountStatus.current_page < accountStatus.last_page-2">&hellip;</span>
                                                        </li>

                                                        <li>
                                                            <button class="pagination-link" 
                                                                v-show="accountStatus.current_page <= accountStatus.last_page - 2" 
                                                                @click.prevent="changePage(accountStatus.last_page)">{{accountStatus.last_page}}</button>
                                                        </li>                                          
                                                    </ul>
                                                </nav>
                                            </div>
                                        </footer> -->
                                    </div>
                                </div>
                                <span class="content is-small">* Salvo Error U Omisión. Ante inconsistencias consultar al siguiente correo: <a href="mailto:facturacion@bambi.com.ar">facturacion@bambi.com.ar</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /Orders List -->
            </div>
            <!-- /Container -->
        </div>   
    </div>   
</template>

<script>
import { mapGetters, mapActions } from 'vuex' 
import navigation from '../components/navigation'

export default {
    name: 'account-status',
    data() {
        return {
            estados: null
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
            accountStatus: 'accountStatus/accountStatus',
        }),
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'accountStatus/getAccountStatus',
            getDocument: 'documents/getDocument'
        }),        
        changePage(page){
            this.getAccountStatus(page);
        },
        attemptGetDocument(docName, docType){
            let data = { docName, docType };
            this.getDocument(data);
        },
        getNow() {
            const today = new Date();
            const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = date +' '+ time;
            return this.timestamp = dateTime;
        }
    },
    components: {
        navigation
    }
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px !important;
}
.table-wrapper{
    overflow-x: auto;
}
.table tr.is-selected{
    background-color: #ddd;
    border-color: white;
    color: #999;
    font-weight: 500;
    border-bottom: 2px solid #ccc;
}

.m-t-r{
    margin: 0.75rem 0.75rem 0;
}

svg.svg-button{
    width: 18px;
    height: 18px;
    -webkit-transition: all .3s;
    transition: all .3s;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    stroke-width: 1.2px;
}
.order-long-card{
    flex-direction: column;
    margin-bottom: 5px;
}

.table thead tr.order-header th{
    padding: 15px 0px 30px;
    border: none;
    vertical-align: middle;
}

.order-long-card .order-header .seuo{
    display: block;
    font-size: .70rem;
    text-align: right;
    margin-top: 5px;
}
/* 
.pagination > button, .pagination ul li > button {
    cursor: pointer;
}
.pagination-link.is-current {
    color: #fff;
    background-color: #009BDB;
    border: 2px solid #009BDB;
}
.card-footer{
    margin-top: 30px;
}
.pagination-previous, .pagination-next, .pagination-link {
    color: #009BDB;
    border: 2px solid #009BDB;
    background: none;
}
.pagination-previous:not([disabled]):hover, .pagination-next:not([disabled]):hover, .pagination-link:hover {
    color: #009BDB;
    border: 2px solid #009BDB;
    background-color: #dbdbdb;
} */
</style>